<template>
  <div id="app">
    <router-view />
    <el-drawer
      append-to-body
      :visible.sync="isDrawerOpen"
      :show-close="false"
      :with-header="false"
      size="50%"
      :modal="false"
      direction="rtl">
      <openai @closeDrawer="handleCloseDrawer"></openai>
    </el-drawer>
     <el-tooltip class="item" effect="dark" content="我是您的智能助手kimi,请双击唤醒我吧!" placement="right">
      <FloatingButton @openDrawer="handelOpenDrawer"></FloatingButton>
     </el-tooltip>
  </div>
</template>
<script>
  import openai from './components/OpenAi'
  import FloatingButton from './components/FloatingButton'
  export default {
    components:{
      openai,
      FloatingButton
    },
    data(){
      return{
        isDrawerOpen:false,
      }
    },
    methods: {
      handelOpenDrawer(){
        this.isDrawerOpen=true       
      },
      handleCloseDrawer(){
        this.isDrawerOpen=false 
      }
    }
  };
</script>
<style>
html,
#app,
body {
  padding: 0;
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-drawer__wrapper{
  z-index: 10001!important;
}
</style>
